module.exports = __webpack_public_path__ + "img/btn-comment.22313c43.png";